/**
 * Ads module endpoints (for future real API integration).
 * For now, the UI consumes mock data only.
 */

export const ADS_ENDPOINTS = {
  OVERVIEW: {
    GET: "/api/v1/ads/admin/overview",
    EXPORT: "/api/v1/ads/admin/overview/export",
  },
  ADVERTISERS: {
    LIST: "/api/v1/ads/admin/advertisers",
    CREATE: "/api/v1/ads/admin/advertisers",
    UPDATE_STATUS: "/api/v1/ads/admin/advertisers/{id}/status",
    APPROVE: "/api/v1/ads/advertisers/{id}/approve",
    REJECT: "/api/v1/ads/advertisers/{id}/reject",
    BLOCK: "/api/v1/ads/advertisers/{id}/block",
  },
  CAMPAIGNS: {
    LIST: "/api/v1/ads/admin/campaigns",
    CREATE: "/api/v1/ads/admin/campaigns",
    GET_BY_ID: "/api/v1/ads/admin/campaigns/{id}",
    UPDATE: "/api/v1/ads/admin/campaigns/{id}",
    UPDATE_STATUS: "/api/v1/ads/admin/campaigns/{id}/status",
    VIEW: "/api/v1/ads/campaigns/{id}",
    STATS_ALL: "/api/v1/ads/admin/campaigns/stats/all",
    STATS_ALL_EXPORT: "/api/v1/ads/admin/campaigns/stats/all/export",
  },
  CREATIVES: {
    LIST: "/api/v1/ads/admin/ads",
    CREATE: "/api/v1/ads/admin/ads",
    GET_BY_ID: "/api/v1/ads/admin/ads/{id}",
    UPDATE: "/api/v1/ads/admin/ads/{id}",
    UPDATE_STATUS: "/api/v1/ads/admin/ads/{id}/status",
    ANALYTICS: "/api/v1/ads/admin/ads/{id}/analytics",
  },
  PLACEMENTS: {
    LIST: "/api/v1/ads/admin/placements",
    UPDATE: "/api/v1/ads/admin/placements/{id}",
    TOGGLE_KILL_SWITCH: "/api/v1/ads/placements/{id}/kill-switch",
  },
  REPORTS: {
    LIST: "/api/v1/ads/reports",
    EXPORT: "/api/v1/ads/reports/export",
  },
  BILLING: {
    LIST: "/api/v1/ads/admin/billings",
  },
  AUDIT_LOGS: {
    LIST: "/api/v1/ads/admin/audit-logs",
  },
} as const;

